export const formatDescription = (text) => {
  if (!text) return '';

  let formatted = text;

  // 1. Corrige tags HTML mal formatadas
  // Troca <i> que deveria ser </i> quando está no final ou seguido de espaço
  formatted = formatted.replace(/<i>(\s*)$/gm, '</i>$1');
  formatted = formatted.replace(/([^>])<i>(\s*)$/gm, '$1</i>$2');

  // 2. Garante que todas as tags <i> tenham fechamento correto
  const openTags = (formatted.match(/<i>/g) || []).length;
  const closeTags = (formatted.match(/<\/i>/g) || []).length;

  if (openTags > closeTags) {
    // Adiciona tags de fechamento faltantes
    formatted = formatted.replace(/<i>/g, (match, offset) => {
      // Se for a última tag <i> e não tiver fechamento
      const remainingOpen = (formatted.slice(offset + 3).match(/<i>/g) || [])
        .length;
      if (remainingOpen === 0) {
        return '<i>';
      }
      return match;
    });

    // Adiciona </i> no final se necessário
    const finalOpenTags = (formatted.match(/<i>/g) || []).length;
    const finalCloseTags = (formatted.match(/<\/i>/g) || []).length;
    if (finalOpenTags > finalCloseTags) {
      formatted += '</i>';
    }
  }

  // 3. Converte quebras de linha para <br/>
  formatted = formatted
    .replace(/\r\n/g, '<br/>')
    .replace(/\n/g, '<br/>')
    .replace(/\r/g, '<br/>');

  // 4. Remove <br/> duplicados (opcional)
  formatted = formatted.replace(/(<br\/>\s*){3,}/g, '<br/><br/>');

  return formatted;
};

// Função para truncar HTML mantendo tags
export const truncateHtml = (html, limit = 80) => {
  if (!html) return '';

  // Remove tags para contar caracteres
  const textOnly = html.replace(/<[^>]*>/g, '');

  if (textOnly.length <= limit) return html;

  // Encontra o último espaço antes do limite
  const truncatedText = textOnly.substring(0, limit);
  const lastSpace = truncatedText.lastIndexOf(' ');
  const finalText = truncatedText.substring(0, lastSpace);

  return `${finalText}...`;
};
